import React from 'react';
import './index.scss';
import { getAvgSentimentAndColor } from '../cloud/chart';
export default function WordItem({
  word,
  word_cn,
  word_en,
  count,
  type,
  active = false,
  text,
  handleClick,
  avg_sentiment,
  position,
}: {
  word: string;
  word_cn: string;
  word_en: string;
  count: number;
  type?: string;
  active?: boolean;
  text: string;
  handleClick?: (value) => void;
  avg_sentiment: number;
  position: string;
}) {
  const [category] = getAvgSentimentAndColor(avg_sentiment);

  return (
    <span
      className={`dbo-keyword ${
        category == 'Positive'
          ? ' dbo-keyword--green'
          : category == 'Negative'
          ? ' dbo-keyword--red'
          : ''
      } ${active ? ' is-selected' : ''}`}
      onClick={() => {
        handleClick?.({
          word,
          word_cn,
          word_en,
          position,
        });
      }}
    >
     {text}
     {count ? <span className="strong-text">{count}</span> : ''}
    </span>
  );
}
